<!-- <script setup lang='ts' >
</script>

<template>
    <p>Copyright@2025 虔智科技有限公司 ver:5.1.6.8</p>
    <p>系統代理商加盟: 0917-818-339 歐文</p>
    <p>Line官方:</p>
    <img class="user-image" src="/S_gainfriends_2dbarcodes_GW.png" alt="Line" />

</template>

<style>
.user-image {
  width: 150px; /* 固定寬度 */
  height: 150px; /* 固定高度 */
  object-fit: cover; /* 確保圖片填滿容器並裁剪多餘部分 */
  border-radius: 4px; /* 可選：圓角效果 */
}
.contact-link {
  color: #FF69B4;
  font-size: 20px;
  text-decoration: none;
}
</style> -->

<script setup lang="ts">
import { ref } from 'vue'

const showModal = ref(false)

function openModal() {
  showModal.value = true
}

function closeModal() {
  showModal.value = false
}
</script>

<template>
  <p>Copyright©2025 虔智科技有限公司 ver:5.1.6.8</p>
  <p>系統代理商加盟: 0917-818-339 歐文</p>
  <p>官方Line:</p>
  <img
    class="user-image"
    src="/S_gainfriends_2dbarcodes_GW.png"
    alt="Line"
    @click="openModal"
  />

  <!-- 放大圖 modal -->
  <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <span class="close-button" @click="closeModal">&times;</span>
      <img class="modal-image" src="/S_gainfriends_2dbarcodes_GW.png" alt="Line"  title="點擊可以放大" />
    </div>
  </div>
</template>

<style scoped>
.user-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}

/* Modal 覆蓋層 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* Modal 內容 */
.modal-content {
  position: relative;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
}

.modal-image {
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
}

/* 關閉按鈕 */
.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 30px;
  cursor: pointer;
  color: #333;
}
</style>
